import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import Age from '@blade-sxp/portrait-center/pages/components/dougnuts/age.vue';
import Gender from '@blade-sxp/portrait-center/pages/components/dougnuts/gender.vue';
import Indentity from '@blade-sxp/portrait-center/pages/components/dougnuts/indentity.vue';
import Expression from '@blade-sxp/portrait-center/pages/components/dougnuts/expression.vue';
import Customers from '@blade-sxp/portrait-center/pages/components/dougnuts/customers.vue';
let default_1 = class default_1 extends Vue {
    dates;
    zoneType;
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
default_1 = __decorate([
    Component({
        name: 'dougnuts',
        components: { Age, Gender, Indentity, Expression, Customers },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
